import { render, staticRenderFns } from "./AppNotifications.vue?vue&type=template&id=57574964&"
import script from "./AppNotifications.vue?vue&type=script&lang=ts&"
export * from "./AppNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./AppNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports